import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import css from './RolSelector.module.css'

const ROLES = [
  { value: 'USER', label: 'USER' },
  { value: 'ADMIN', label: 'ADMIN' },
  { value: 'COORDINADOR', label: 'COORDINADOR' },
  { value: 'MARKETING', label: 'MARKETING' },
  { value: 'DEVELOPER', label: 'DEVELOPER' },
  { value: 'CONSULTOR', label: 'CONSULTOR (solo lectura)' }
]

const RolSelector = ({ className, name, label, value, onChange }) => {
  return (
    <FormControl className={`${className} ${css.main}`} variant='standard'>
      <InputLabel id={name}>{label}</InputLabel>
      <Select
        labelId={name}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        label={label}
      >
        {ROLES.map(rol => (
          <MenuItem key={rol.value} value={rol.value}>
            {rol.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default RolSelector
